'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nextMoment = require('../../../next-moment/lib/index.js');

var _nextMoment2 = _interopRequireDefault(_nextMoment);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _nextButton = require('../../../next-button/lib/index.js');

var _nextButton2 = _interopRequireDefault(_nextButton);

var _utils = require('./utils.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var QuickTool = (_temp = _class = function (_Component) {
    _inherits(QuickTool, _Component);

    function QuickTool() {
        _classCallCheck(this, QuickTool);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    QuickTool.prototype.onChange = function onChange(type) {
        var _props;

        for (var _len = arguments.length, others = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            others[_key - 1] = arguments[_key];
        }

        (_props = this.props).onChange.apply(_props, [type].concat(others));
    };

    QuickTool.prototype.isNowValid = function isNowValid() {
        var disabledDate = this.props.disabledDate;

        var calendarDate = (0, _utils.getCalendarDate)((0, _nextMoment2['default'])());
        return (0, _utils.isValidCalendarDate)(calendarDate, disabledDate);
    };

    QuickTool.prototype.render = function render() {
        var _classNames,
            _this2 = this;

        var _props2 = this.props,
            locale = _props2.locale,
            module = _props2.module,
            shortcuts = _props2.shortcuts,
            value = _props2.value,
            mode = _props2.mode;

        var prefix = this.context.prefix || this.props.prefix;

        var disabledSelect = function disabledSelect() {
            if (value instanceof Array) {
                return !value[0] || !value[1];
            } else {
                return !value;
            }
        };
        var isNowValid = this.isNowValid();

        var selectCls = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, prefix + 'date-picker-quick-tool-select', true), _defineProperty(_classNames, prefix + 'date-picker-quick-tool-select-disabled', disabledSelect()), _classNames));
        var selectDateAttrs = {
            onClick: disabledSelect() ? null : this.onChange.bind(this, 'select-date')
        };
        var selectTimeAttrs = {
            onClick: disabledSelect() ? null : this.onChange.bind(this, 'select-time')
        };
        return _react2['default'].createElement(
            'div',
            { className: prefix + 'date-picker-quick-tool', ref: 'date-picker-quick-tool' },
            module.indexOf('now') >= 0 ? isNowValid ? _react2['default'].createElement(
                'span',
                { className: prefix + 'date-picker-quick-tool-now', onClick: this.onChange.bind(this, 'now') },
                locale.now
            ) : _react2['default'].createElement(
                'span',
                { className: prefix + 'date-picker-quick-tool-now-disabled' },
                locale.now
            ) : null,
            shortcuts.map(function (item) {
                return _react2['default'].createElement(
                    'span',
                    { key: item, className: prefix + 'date-picker-quick-tool-shortcut', onClick: _this2.onChange.bind(_this2, 'quick-select', item) },
                    item
                );
            }),
            _react2['default'].createElement(
                _nextButton2['default'],
                { size: 'small', type: 'primary', className: prefix + 'date-picker-quick-tool-ok', onClick: this.onChange.bind(this, 'ok') },
                locale.ok
            ),
            module.indexOf('select') >= 0 ? mode === 'date' ? _react2['default'].createElement(
                'span',
                _extends({ className: selectCls }, selectDateAttrs),
                locale.selectDate
            ) : _react2['default'].createElement(
                'span',
                _extends({ className: selectCls }, selectTimeAttrs),
                locale.selectTime
            ) : null
        );
    };

    return QuickTool;
}(_react.Component), _class.propTypes = {
    prefix: _propTypes2['default'].string,
    value: _propTypes2['default'].any,
    module: _propTypes2['default'].array,
    shortcuts: _propTypes2['default'].array,
    mode: _propTypes2['default'].oneOf(['decade', 'year', 'month', 'date']),
    locale: _propTypes2['default'].object,
    disabledDate: _propTypes2['default'].func,
    onChange: _propTypes2['default'].func
}, _class.defaultProps = {
    prefix: 'next-',
    mode: 'month',
    shortcuts: [],
    onChange: function onChange() {}
}, _class.contextTypes = {
    prefix: _propTypes2['default'].string
}, _temp);
QuickTool.displayName = 'QuickTool';
exports['default'] = QuickTool;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-date-picker/lib/view/quick-tool.js
// module id = 114
// module chunks = 0